import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = () => {
  const metrics = [
    {
      label: 'Total Reported',
      value: '342',
      change: '+12.5%',
      trend: 'up',
      icon: 'AlertTriangle',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Rectification Rate',
      value: '87.3%',
      change: '+3.2%',
      trend: 'up',
      icon: 'CheckCircle',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Pending Items',
      value: '43',
      change: '-8.1%',
      trend: 'down',
      icon: 'Clock',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      label: 'Critical Alerts',
      value: '7',
      change: '+2',
      trend: 'up',
      icon: 'AlertCircle',
      color: 'text-red-500',
      bgColor: 'bg-red-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            <span className={`text-sm font-medium ${metric?.trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
              {metric?.change}
            </span>
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{metric?.value}</h3>
          <p className="text-sm text-muted-foreground">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;